import { types } from 'mobx-state-tree';
import type { Instance } from 'mobx-state-tree/dist/core/type/type';

import { BaseModel } from '@/stores/shared';

export const HierarchicalTeamModel = types.compose(
  BaseModel,
  types.model({
    name: types.string,
    path: types.string,
  }),
);

export type HierarchicalTeamModelType = Instance<
  typeof HierarchicalTeamModel
> & {};
